import styled from "styled-components";

export const StyledContainer = styled("div")`
  display:flex;
  flex-direction:column;
  text-align: center;
  justify-content: center;
  align-items: center;
`;

export const ImageContainer = styled("div")`
  display:flex;
  text-align: center;
  justify-content: center;
  align-items: center;
`;



export const UnderconstructionBox = styled("div")`
  opacity:50%;

`;
